import { $currentPathLocation } from './states';
import { setCurrentPathLocation } from './events';

// Set current path location
$currentPathLocation.on(setCurrentPathLocation, (_, data) => data);
